<template>
  <div>
    <!--Intro Banner - Parallax-->
    <section class="topBanner" ref="parallaxBanner" :style="{ backgroundPositionY: parallaxOffset + 'px' }">
      <div class="bannerOverlay">
        <h1 class="bannerTitle">{{ $t('intro.title') }}</h1>
        <p class="bannerSubtitle">{{ $t('intro.subtitle') }}</p>
      </div>
    </section>

    <!--Section principale - Expertise-->
    <section class="gridpad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="10">
          <div class="sectionBox">
            <h2 class="sectionTitle txt-c">{{ $t('expertise.title') }}</h2>
            <p class="mt-5 txt-j" v-html="$t('expertise.intro')"></p>
            <p class="mt-4 interventionLabel"><strong>{{ $t('expertise.listLabel') }}</strong></p>
            <ul class="serviceList mt-3">
              <li class="serviceItem">
                <span class="serviceItemTitle">{{ $t('expertise.item1Title') }}</span>
                <span v-html="$t('expertise.item1Text')"></span>
              </li>
              <li class="serviceItem">
                <span class="serviceItemTitle">{{ $t('expertise.item2Title') }}</span>
                <span v-html="$t('expertise.item2Text')"></span>
              </li>
              <li class="serviceItem">
                <span class="serviceItemTitle">{{ $t('expertise.item3Title') }}</span>
                <span v-html="$t('expertise.item3Text')"></span>
              </li>
              <li class="serviceItem">
                <span class="serviceItemTitle">{{ $t('expertise.item4Title') }}</span>
                <span v-html="$t('expertise.item4Text')"></span>
              </li>
            </ul>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Section ContactUs-->
    <contactUs/>

    <!--Cards Why Vacuum-->
    <section class="sectionPad gridpad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" class="txt-c mb-8">
          <h2 class="sectionTitle">{{ $t('why.title') }}</h2>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center">
        <v-col cols="12" sm="6" md="4" class="whyCard" v-for="(card, i) in whyCards" :key="i">
          <div class="whyCardOverlay" @click="navigateContact">
            <span class="whyCardOverlayText">Nous contacter</span>
          </div>
          <div class="whyCardIcon" v-html="card.icon"></div>
          <h3 class="whyCardTitle">{{ card.title }}</h3>
          <p class="whyCardText">{{ card.text }}</p>
        </v-col>
      </v-row>
    </section>

    <!--Section Photos - Équipement Teamco-->
    <section class="bgPhotos gridpad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" class="txt-c mb-4">
          <h2 class="sectionTitle">{{ $t('equipment.title') }}</h2>
          <p class="equipmentSubtitle">{{ $t('equipment.subtitle') }}</p>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="4" md="4" sm="12" v-for="(photo, index) in photos" :key="index">
          <div class="photoCard" @click="openLightbox(index)">
            <div class="photoImg" :style="{ backgroundImage: 'url(' + photo.src + ')' }">
              <div class="photoHoverOverlay">
                <span class="zoomIcon"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Section Caméra Inspection-->
    <section class="sectionPad v-primary-light-1">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="8" class="txt-j">
          <div class="zonePad">
            <div class="cameraTag mb-3">Service additionnel</div>
            <h2 class="sectionTitle mb-4">Inspection par caméra des canalisations</h2>
            <p>Grâce à notre caméra d'inspection spécialisée, nous pouvons explorer vos canalisations, tuyaux et infrastructures souterraines sans excavation. Cette technologie nous permet de détecter rapidement les obstructions, bris ou problèmes internes avant d'intervenir.</p>
            <ul class="cameraList mt-4">
              <li class="cameraItem">
                <span class="cameraCheck">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
                <span>Détection d'obstructions et de bris de tuyaux</span>
              </li>
              <li class="cameraItem">
                <span class="cameraCheck">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
                <span>Inspection des drains, fosses et conduits souterrains</span>
              </li>
              <li class="cameraItem">
                <span class="cameraCheck">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
                <span>Diagnostic précis avant toute intervention</span>
              </li>
              <li class="cameraItem">
                <span class="cameraCheck">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
                <span>Résidentiel, commercial et industriel</span>
              </li>
            </ul>
            <router-link class="cameraBtn mt-6" to="/contact">Demander une inspection →</router-link>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Zone Desservie-->
    <section class="sectionPad v-primary-light-1">
      <v-row>
        <v-col cols="12" lg="7" class="txt-j">
          <div class="zonePad">
            <h2 class="sectionTitle mb-4">{{ $t('zone.title') }}</h2>
            <p>{{ $t('zone.intro') }}</p>
            <ul class="zoneList mt-4">
              <li v-for="(item, i) in zoneItems" :key="i" class="zoneItem">
                <h3 class="zoneliTitle">{{ item.city }}</h3>
                <p class="zoneliText"> : {{ item.text }}</p>
              </li>
            </ul>
          </div>
        </v-col>
        <v-col cols="12" lg="5" class="pa-0 d-flex align-center justify-center mapZoneVCol">
          <div class="mapImg"></div>
        </v-col>
      </v-row>
    </section>

    <!--Lightbox Popup-->
    <transition name="lightbox-fade">
      <div v-if="lightboxOpen" class="lightboxBackdrop" @click.self="closeLightbox">
        <div class="lightboxContainer">

          <!-- Bouton fermer -->
          <button class="lightboxClose" @click="closeLightbox">&times;</button>

          <!-- Bouton précédent -->
          <button class="lightboxNav lightboxPrev" @click="prevPhoto">&#8592;</button>

          <!-- Image -->
          <img class="lightboxImg" :src="photos[lightboxIndex].src" :alt="'Photo équipement ' + (lightboxIndex + 1)" />

          <!-- Bouton suivant -->
          <button class="lightboxNav lightboxNext" @click="nextPhoto">&#8594;</button>

          <!-- Compteur -->
          <div class="lightboxCounter">{{ lightboxIndex + 1 }} / {{ photos.length }}</div>
        </div>
      </div>
    </transition>

  </div>
</template>

<style scoped>
  p { font-size: 18px; color: rgba(var(--menuColor), 0.6); }
  .gridpad { padding: 50px 100px; }

  /*#region Banner Parallax*/
  .topBanner {
    height: 600px;
    background-image: url('../../public/Resources/images/Vaccum/vacuum-banner.jpg');
    background-attachment: fixed;
    background-position: center 30%;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    will-change: background-position-y;
  }
  .bannerOverlay {
    background-color: rgba(0, 0, 0, 0.45);
    padding: 40px 70px;
    border-radius: 8px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    max-width: 700px;
  }
  .bannerTitle {
    color: #ffffff;
    font-weight: 700;
    font-size: 32px;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin: 0;
  }
  .bannerSubtitle {
    color: rgba(255,255,255,0.85);
    font-size: 18px;
    margin: 0;
  }
  /*#endregion*/

  .sectionPad { padding: 50px 0px; }

  /*#region Why Cards*/
  .whyCard {
    position: relative;
    max-width: 360px;
    padding: 30px 24px;
    margin: 12px;
    border-radius: 6px;
    border-top: 4px solid rgb(var(--primary));
    background-color: #ffffff;
    box-shadow: 0 0 12px rgba(var(--primary), 0.3);
    transition: transform 0.35s ease, box-shadow 0.35s ease, border-color 0.35s ease;
    animation: slideUpFade 0.6s ease both;
    overflow: hidden;
  }
  .whyCard:nth-child(1) { animation-delay: 0.0s; }
  .whyCard:nth-child(2) { animation-delay: 0.15s; }
  .whyCard:nth-child(3) { animation-delay: 0.30s; }
  @keyframes slideUpFade {
    from { opacity: 0; transform: translateY(30px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .whyCard:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 30px rgba(var(--primary), 0.35);
    border-top-color: rgb(var(--secondary));
  }
  .whyCardOverlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(var(--primary), 0.88), rgba(var(--secondary), 0.88));
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    transition: opacity 0.3s ease;
    cursor: pointer;
  }
  .whyCard:hover .whyCardOverlay { opacity: 1; }
  .whyCardOverlayText {
    color: #fff;
    font-weight: 700;
    font-size: 20px;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  .whyCardIcon {
    font-size: 36px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
  }
  .whyCardTitle {
    font-size: 20px;
    color: rgb(var(--primary));
    font-weight: 700;
    margin-bottom: 12px;
  }
  .whyCardText {
    font-size: 16px !important;
    color: rgba(var(--menuColor), 0.65);
    text-align: justify;
    line-height: 1.6;
  }
  /*#endregion*/

  /*#region Zone Desservie*/
  .zonePad { padding: 20px 60px; }
  .zoneList { list-style: none; padding: 0; }
  .zoneItem { padding: 10px 0px; border-bottom: 1px solid rgba(var(--menuColor), 0.1); }
  .zoneliTitle { display: inline; font-size: 18px; color: rgb(var(--primary)); font-weight: 700; }
  .zoneliText { display: inline; font-size: 16px; color: rgba(var(--menuColor), 0.6); }
  .mapImg {
    height: 450px;
    width: 80%;
    background-image: url("../../public/Resources/images/logo/map.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    transform: rotate(20deg);
    opacity: 0.4;
  }
  /*#endregion*/
  .sectionBox { padding: 20px 0px 32px 0px; }
  .sectionTitle { color: rgb(var(--secondary)); font-weight: 700; font-size: 26px; }
  .interventionLabel { font-size: 18px; color: rgba(var(--menuColor), 0.8); }
  .serviceList { list-style: none; padding: 0 20px; }
  .serviceItem {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 14px 0px;
    border-bottom: 1px solid rgba(var(--menuColor), 0.1);
    font-size: 18px;
    color: rgba(var(--menuColor), 0.6);
  }
  .serviceItem::before {
    content: '▸';
    color: rgb(var(--primary));
    font-size: 20px;
    flex-shrink: 0;
    margin-top: 1px;
  }
  .serviceItemTitle {
    color: rgb(var(--secondary));
    font-weight: 600;
    margin-right: 6px;
    white-space: nowrap;
  }
  /*#endregion*/

  /*#region Photos + Hover*/
  .bgPhotos { background-color: rgb(var(--tierce2)); }
  .equipmentSubtitle { font-size: 17px; color: rgba(var(--menuColor), 0.55); margin-top: 6px; }
  .photoCard {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0,0,0,0.15);
    cursor: pointer;
    margin-bottom: 16px;
  }
  .photoImg {
    height: 280px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    transition: transform 0.4s ease;
    position: relative;
  }
  .photoCard:hover .photoImg { transform: scale(1.04); }
  .photoHoverOverlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0,0,0,0);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease;
  }
  .photoCard:hover .photoHoverOverlay { background-color: rgba(0,0,0,0.35); }
  .zoomIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    filter: drop-shadow(0 2px 6px rgba(0,0,0,0.6));
  }
  .photoCard:hover .zoomIcon { opacity: 1; }
  .pumpThumbCard:hover .zoomIcon { opacity: 1; }
  /*#endregion*/

  /*#region Caméra Inspection*/
  .cameraTag { display: inline-block; background-color: rgb(var(--primary)); color: #ffffff; font-size: 12px; font-weight: 700; padding: 5px 14px; border-radius: 3px; text-transform: uppercase; letter-spacing: 1px; }
  .cameraList { list-style: none; padding: 0; }
  .cameraItem { display: flex; align-items: center; gap: 12px; padding: 10px 0; border-bottom: 1px solid rgba(var(--menuColor), 0.08); font-size: 16px; color: rgba(var(--menuColor), 0.7); }
  .cameraCheck { width: 26px; height: 26px; flex-shrink: 0; background-color: rgb(var(--primary)); border-radius: 50%; display: flex; align-items: center; justify-content: center; }
  .cameraBtn { display: inline-block; background-color: rgb(var(--secondary)); color: #ffffff; padding: 12px 28px; border-radius: 4px; font-weight: 700; font-size: 14px; text-decoration: none; text-transform: uppercase; letter-spacing: 1px; transition: background-color 0.25s, transform 0.25s; }
  .cameraBtn:hover { background-color: rgb(var(--primary)); transform: translateY(-2px); }
  /*#endregion*/

  /*#region Lightbox*/
  .lightboxBackdrop {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.88);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lightboxContainer {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 90vw;
    max-height: 90vh;
    z-index: 100000;
  }
  .lightboxImg {
    max-width: 85vw;
    max-height: 85vh;
    border-radius: 6px;
    box-shadow: 0 8px 40px rgba(0,0,0,0.6);
    object-fit: contain;
    display: block;
  }
  .lightboxClose {
    position: fixed;
    top: 20px;
    right: 28px;
    font-size: 44px;
    color: #ffffff;
    background: none;
    border: none;
    cursor: pointer;
    line-height: 1;
    opacity: 0.85;
    transition: opacity 0.2s;
    z-index: 100001;
  }
  .lightboxClose:hover { opacity: 1; }
  .lightboxNav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(255,255,255,0.15);
    border: 2px solid rgba(255,255,255,0.5);
    color: #fff;
    font-size: 26px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;
    z-index: 100001;
  }
  .lightboxNav:hover { background-color: rgba(255,255,255,0.3); }
  .lightboxPrev { left: -65px; }
  .lightboxNext { right: -65px; }
  .lightboxCounter {
    position: absolute;
    bottom: -36px;
    left: 50%;
    transform: translateX(-50%);
    color: rgba(255,255,255,0.7);
    font-size: 15px;
  }
  .lightbox-fade-enter-active, .lightbox-fade-leave-active { transition: opacity 0.25s ease; }
  .lightbox-fade-enter-from, .lightbox-fade-leave-to { opacity: 0; }
  /*#endregion*/

  @media handheld, only screen and (max-width: 600px) {
    .gridpad { padding: 30px 15px; }
    .bannerTitle { font-size: 24px; }
    .bannerOverlay { padding: 25px 20px; }
    .serviceItem { flex-direction: column; gap: 4px; }
    .serviceItemTitle { white-space: normal; }
    .topBanner { background-attachment: scroll; }
    .lightboxPrev { left: -40px; }
    .lightboxNext { right: -40px; }
    .lightboxNav { width: 36px; height: 36px; font-size: 18px; }
    .whyCard { max-width: 100% !important; margin: 8px 0; padding: 20px 16px; }
    .whyCardText { text-align: left; }
    .zonePad { padding: 20px 15px; }
    .mapZoneVCol { display: none !important; }
  }
  @media handheld, only screen and (max-width: 960px) {
    .gridpad { padding: 30px 25px; }
    .photoImg { height: 220px; }
    .topBanner { background-attachment: scroll; }
    .whyCard { max-width: 100% !important; }
    .zonePad { padding: 20px 25px; }
    .mapZoneVCol { display: none !important; }
  }
  @media handheld, only screen and (max-width: 1279px) {
    .gridpad { padding: 40px 40px; }
    .zonePad { padding: 20px 30px; }
  }
</style>

<script>
  import pageTranslations from '../../public/Resources/i18N/vacuum.json';
  import contactUs from '@/components/bannerContactUs.vue';

  export default {
    name: 'VacuumPage',
    data: () => ({
      parallaxOffset: 0,
      lightboxOpen: false,
      lightboxIndex: 0,
      whyCards: [
        {
          icon: '⚡',
          title: 'Intervention rapide',
          text: "Nous intervenons rapidement pour minimiser les interruptions de vos opérations. Service d'urgence disponible."
        },
        {
          icon: '🔧',
          title: 'Équipement spécialisé',
          text: "Nos unités vacuum Teamco de pointe permettent des interventions précises et efficaces pour tous types de systèmes."
        },
        {
          icon: '✅',
          title: 'Tous secteurs desservis',
          text: "Résidentiel, commercial ou industriel — nos équipes s'adaptent à vos besoins et à vos contraintes opérationnelles."
        },
      ],
      zoneItems: [
        { city: 'Drummondville', text: "Au coeur de notre activité, nous répondons promptement à tous les appels locaux." },
        { city: 'Saint-Hyacinthe', text: "Une présence forte pour répondre rapidement aux demandes résidentielles et commerciales." },
        { city: 'Trois-Rivières', text: "Services complets pour les secteurs résidentiel, agricole et commercial." },
        { city: 'Centre-du-Québec', text: "Couverture complète de la région pour tous vos besoins en pompage vacuum." },
        { city: 'Sorel-Tracy', text: "Interventions rapides pour urgences et maintenances programmées." },
        { city: 'Estrie', text: "Présents pour tous vos besoins résidentiel, commercial et industriel." },
      ],
      photos: [
        { src: '/Resources/images/Vaccum/vaccum-1.jpg' },
        { src: '/Resources/images/Vaccum/vaccum-2.jpg' },
        { src: '/Resources/images/Vaccum/vaccum-3.jpg' },
      ],
    }),
    mounted() {
      this.$i18n.mergeLocaleMessage('fr', pageTranslations.fr);
      this.$i18n.mergeLocaleMessage('en', pageTranslations.en);
      window.addEventListener('scroll', this.handleParallax);
      window.addEventListener('keydown', this.handleKeydown);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleParallax);
      window.removeEventListener('keydown', this.handleKeydown);
    },
    methods: {
      navigateContact() { this.$router.push('/contact'); },
      handleParallax() {
        if (!this.$refs.parallaxBanner) return;
        this.parallaxOffset = Math.round(window.scrollY * 0.4);
      },
      openLightbox(index) {
        this.lightboxIndex = index;
        this.lightboxOpen = true;
        document.body.style.overflow = 'hidden';
      },
      closeLightbox() {
        this.lightboxOpen = false;
        document.body.style.overflow = '';
      },
      nextPhoto() {
        this.lightboxIndex = (this.lightboxIndex + 1) % this.photos.length;
      },
      prevPhoto() {
        this.lightboxIndex = (this.lightboxIndex - 1 + this.photos.length) % this.photos.length;
      },
      handleKeydown(e) {
        if (!this.lightboxOpen) return;
        if (e.key === 'Escape')      this.closeLightbox();
        if (e.key === 'ArrowRight')  this.nextPhoto();
        if (e.key === 'ArrowLeft')   this.prevPhoto();
      },
    },
    components: {
      contactUs,
    },
  }
</script>